// 引入 lodopFuns.js 的 getLodop 方法
import { getLodop } from "../lodopFun";
import util from "../../../util/date";
import { Axios } from "@/utils/plugin/axios-plugin";
import { Main } from "element-ui";
import printmb2 from "../mb/2";
import printmb3 from "../mb/3";

// strPrintTaskName:打印名称  printDate:打印日期  printModel:打印模块  date:数据
export default function(Main) {
  const LODOP = getLodop();
  LODOP.PRINT_INITA(0, 0, 800, 1600, "");
  var Entry = Main.entry1;

  for (let x = 0; x < Entry.length; x++) {
    var Info = Entry[x];
    var bxr =
      '<style> table,td,th {border: 1px solid black;border-style: solid;border-collapse: collapse}</style><p>报销人信息：</p><table border="1" width="700" >';

    bxr +=
      "<tr align=center > <td >序号</td> <td >报销人</td><td >归属部门</td><td >项目名称</td><td >费用类型</td><td >金额</td> </tr>";
    for (let index = 0; index < Info.Entry.length; index++) {
      const element = Info.Entry[index];
      var temp = "<tr align=center ><td>";
      temp += index + 1 + "</td><td>";
      temp += element.StaffName + "</td><td>";
      temp += element.CostDepName + "</td><td>";
      temp += element.SubjectName + "</td><td>";
      temp += element.CostName + "</td><td>";
      temp += util.formatNum.numFormat(element.Amount) + "</td></tr>";
      bxr += temp;
    }
    bxr += "</table>";
    var groups = [];
    var _EntryInvoiceinfo = JSON.parse(JSON.stringify(Info.EntryInvoiceinfo));
    var isgou = true;
    _EntryInvoiceinfo.forEach(function(o) {
      if (o.Type === 99) o.InvoiceNo = "/";
      if (o.IsUpByPeo === "1") o.InvoiceNo = o.InvoiceNo + "*";

      // if (o.Status != 0) isgou = false;
      if (util.formatDate.datedifference(o.InvoiceDate, new Date()) > 365)
        isgou = false;
    });

    _EntryInvoiceinfo.forEach(function(o) {
      groups.push(o.ItemName);
    });
    groups = Array.from(new Set(groups));

    var clinfo = [];
    for (var i = 0, len = groups.length; i < len; i++) {
      var tmps = _EntryInvoiceinfo.filter(
        (name) => name.ItemName === groups[i]
      );
      var ItemName = groups[i];
      // var zs = tmps.length;
      var zs = 0;
      var InvoiceNo = "";
      var Amount = 0;
      var InvoiceDate = "";
      //
      for (var j = 0, len2 = tmps.length; j < len2; j++) {
        var tmp = tmps[j];
        InvoiceNo += tmp.InvoiceNo + ",";
        Amount += tmp.Amount;
        zs += tmp.Count;
        InvoiceDate += tmp.InvoiceDate + ",";
      }
      Amount = Amount.toFixed(2);

      clinfo.push({
        ItemName: ItemName,
        zs: zs,
        InvoiceNo: InvoiceNo,
        Amount: Amount,
        InvoiceDate: InvoiceDate,
      });
    }

    var sum1 = clinfo.reduce(function(prev, cur) {
      return cur.zs + prev;
    }, 0);

    var sum2 = clinfo.reduce(function(prev, cur) {
      return parseFloat(cur.Amount) + prev;
    }, 0);
    sum2 = sum2.toFixed(2);

    clinfo.push({
      ItemName: "合计",
      zs: sum1,
      InvoiceNo: "",
      Amount: sum2,
      InvoiceDate: "",
    });

    var fp = bxr + '<p>发票校验详情：</p><table border="1" width="700">';
    // '<style> table,td,th {border: 1px solid black;border-style: solid;border-collapse: collapse}</style><table border="1" width="700">';

    fp +=
      "<tr align=center > <td >序号</td> <td >项目</td><td >发票号码</td><td >金额</td><td >开票日期</td><td >张数</td> </tr>";

    for (let index = 0; index < clinfo.length; index++) {
      const element = clinfo[index];
      var temp = "<tr align=center ><td>";
      temp += index + 1 + "</td><td>";
      temp += element.ItemName + "</td><td>";
      var str = element.InvoiceNo.split(",");
      for (var j = 0, len2 = str.length; j < len2; j++) {
        temp += "<p>" + str[j] + "</p>";
      }
      temp += "</td><td>";
      temp += util.formatNum.numFormat(element.Amount) + "</td><td>";

      var str2 = element.InvoiceDate.split(",");
      for (var j = 0, len2 = str2.length; j < len2; j++) {
        var rq =
          !str2[j] || str2[j] == ""
            ? ""
            : util.formatDate.format(new Date(str2[j]), "yyyy-MM-dd");
        temp += "<p>" + rq + "</p>";
      }
      temp += "</td><td>" + element.zs + "</td></tr>";
      fp += temp;
    }
    fp += "</table>";
    var gou = "&nbsp&nbsp&nbsp&nbsp√&nbsp&nbsp&nbsp&nbsp";
    var statusgou = "";
    if (isgou) statusgou = "&nbsp&nbsp&nbsp&nbsp√&nbsp&nbsp&nbsp&nbsp";
    else statusgou = "&nbsp&nbsp&nbsp&nbsp×&nbsp&nbsp&nbsp&nbsp";

    var jyjg =
      // '<style> table,td,th {border: 1px solid black;border-style: solid;border-collapse: collapse}</style><table border="1"> \
      fp +
      "<br/><p>本次发票校验结果如下： &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp报销人：" +
      Info.CreateBy +
      '<br/></p><table border="1"> \
<tr> \
<td>1.发票无重复</td>\
<td>' +
      gou +
      "</td>\
</tr>\
<tr>\
<td>2.发票日期在6个月内</td>\
<td>" +
      statusgou +
      "</td>\
</tr>\
<tr>\
<td>3.购买方信息准确</td>\
<td>" +
      gou +
      "</td>\
</tr>\
<tr>\
<td>4.本次校验总金额在预算范围内</td>\
<td>" +
      gou +
      "</td>\
</tr>\
</table>";

    var create = "报销人：" + Info.CreateBy;

    var bxrh = 30 + Info.Entry.length * 20;

    var fpxqt = 198 + bxrh + 20;

    var fph = 60 + _EntryInvoiceinfo.length * 35 + 20;
    var fpt = fpxqt + 25;

    var jyt = fpt + fph + 20;

    LODOP.NewPage();
    LODOP.ADD_PRINT_TEXT(26, 312, 167, 20, "江苏辉源供应链管理有限公司");
    LODOP.ADD_PRINT_TEXT(67, 280, 231, 35, "个人费用报销检验回执单");
    LODOP.SET_PRINT_STYLEA(0, "FontSize", 14);
    LODOP.SET_PRINT_STYLEA(0, "Bold", 1);
    // LODOP.ADD_PRINT_TEXT(160, 32, 231, 20, "报销人信息：");
    // LODOP.ADD_PRINT_TEXT(fpxqt, 32, 231, 20, "发票校验详情：");
    // LODOP.ADD_PRINT_TABLE(185, 32, 705, bxrh, bxr);
    debugger;
    // LODOP.ADD_PRINT_TABLE(fpt, 32, 705, fph, fp);
    // LODOP.SET_PRINT_STYLEA(0, "Offset2Top", -280);
    // LODOP.ADD_PRINT_TEXT(jyt, 32, 231, 20, "本次发票校验结果如下：");
    // LODOP.SET_PRINT_STYLEA(0, "LinkedItem", -1);
    LODOP.ADD_PRINT_HTM(150, 32, 300, 900, jyjg);
    LODOP.SET_PRINT_STYLEA(0, "Offset2Top", -120);

    // LODOP.SET_PRINT_STYLEA(0, "LinkedItem", 6);
    // LODOP.ADD_PRINT_TEXT(jyt + 25, 545, 165, 20, create);
    // LODOP.SET_PRINT_STYLEA(0, "LinkedItem", 6);
    LODOP.ADD_PRINT_TEXT(
      112,
      547,
      165,
      45,
      "编号：" +
        Info.BillNo +
        "\r" +
        "\r打印日期：" +
        util.formatDate.format(new Date(), "yyyy-MM-dd")
    );
  }

  LODOP.PREVIEW();
  // LODOP.PRINT_DESIGN();
  //

  if (LODOP.CVERSION)
    CLODOP.On_Return = function(TaskID, Value) {
      debugger;
      if (Main.entry2.IsDG) printmb3(Main.entry2);
      //对公
      else printmb2(Main.entry2); //个人
    };

  // var aa = LODOP.PREVIEW();

  // if (LODOP.PREVIEW() === 0) {
  //
  //   var aa;
  // }

  //
  // var b = LODOP.PREVIEW();

  // if (LODOP.CVERSION) {
  //
  //   LODOP.On_Return = function(TaskID, Value) {
  //     // CLODOP.On_Return = function(TaskID, Value) {
  //     printmb2(Main.entry2);
  //   };
  // }
  //
  // if (LODOP.CVERSION) {
  //
  //   //用CVERSION属性判断是否云打印
  //   LODOP.On_Return = function(TaskID, Value) {
  //
  //     if (Value) alert("已发出实际打印命令！");
  //     else alert("放弃打印！");
  //   };
  //   LODOP.PREVIEW();
  //   return;
  // }
  // if (LODOP.PREVIEW()) alert("已发出实际打印命令");
  // else alert("放弃打印");
}
